module.exports = __webpack_public_path__ + "img/resolve_after_de.1a02561a.svg";